// src/components/common/icons/index.tsx

import React, { forwardRef } from 'react';
// 引入 Orlo 專屬圖示
import SmartSlice from './orlo/SmartSlice';
// 保持原有的 Lucide 導出
export * from 'lucide-react';

// 基本圖示屬性
export interface OrloIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string;
  color?: string;
  strokeWidth?: number;
}

// 建立 Orlo 圖示映射表
type OrloIconsMapType = {
  [key: string]: React.ComponentType<OrloIconProps>;
};

const ORLO_ICONS: OrloIconsMapType = {
  // 只包含 Orlo 專屬圖示
  SmartSlice,
  
  // 可以繼續添加更多 Orlo 專屬圖示
  // TaskSplit: TaskSplit,
  // TimeBoxing: TimeBoxing,
};

// Orlo 圖示名稱類型
export type OrloIconName = keyof typeof ORLO_ICONS;

/**
 * Orlo 專屬圖示組件
 * 使用方式: <OrloIcon name="SmartSlice" size={24} color="blue" />
 */
export const OrloIcon = forwardRef<SVGSVGElement, OrloIconProps & { name: OrloIconName }>(
  ({ name, size = 24, color = 'currentColor', strokeWidth = 2, ...props }, ref) => {
    // 檢查圖示是否存在
    if (!ORLO_ICONS[name]) {
      console.warn(`Orlo 圖示 "${name}" 找不到`);
      return null;
    }

    const IconComponent = ORLO_ICONS[name];
    
    return (
      <IconComponent
        ref={ref}
        size={size}
        color={color}
        strokeWidth={strokeWidth}
        {...props}
      />
    );
  }
);

OrloIcon.displayName = 'OrloIcon';

// 直接導出所有 Orlo 專屬圖示，方便直接使用
export { SmartSlice };

// 提供 Orlo 圖示名稱列表，方便開發參考
export const orloIconList = Object.keys(ORLO_ICONS) as OrloIconName[];

// 添加命名衝突檢測（開發時期警告）
const checkNameConflicts = () => {
    try {
      // 動態引入 Lucide 圖示以獲取其所有圖示名稱
      import('lucide-react').then(lucideModule => {
        const lucideIcons = Object.keys(lucideModule).filter(key => 
          typeof lucideModule[key] === 'function' && key[0] === key[0].toUpperCase()
        );
        
        // 檢查衝突 (修改這一行，添加類型斷言)
        const conflicts = orloIconList.filter(name => lucideIcons.includes(name as string));
        if (conflicts.length > 0) {
          console.warn(`⚠️ 檢測到 Orlo 圖示與 Lucide 圖示名稱衝突: ${conflicts.join(', ')}`);
        }
      });
    } catch (error) {
      // 忽略錯誤，不影響生產環境
    }
  };
  
  // 非生產環境下檢查名稱衝突
  if (process.env.NODE_ENV !== 'production') {
    checkNameConflicts();
  }